import React, { Component } from "react";
import { API } from "aws-amplify";
import { Auth } from "aws-amplify";
import { withRouter } from 'react-router';
import { Nav, Navbar, NavbarBrand, NavDropdown } from "react-bootstrap";
import Routes from "./Routes";
import ClearCache from "react-clear-cache";
import { Alert } from 'reactstrap';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailAddress: "",
      isAuthenticated: false,
      isAuthenticating: false,
      isAdminUser: false,
      alertMessage: ""
    };

  }

  emailAddressHandler  = (email) => {
    this.setState({ emailAddress: email });
  }

  userHasAuthenticated = () => {
    this.componentDidMount();
  }

  async componentDidMount() {
    try {
      this.setState({ alertMessage: ""});
      if (await Auth.currentSession()) {
        var admin = this.state.isAdminUser;
        var userEmail = "";
        await Auth.currentAuthenticatedUser({ bypassCache: false }).then(async user => {
          userEmail = user.attributes.email;
          var licenseId = sessionStorage.getItem("licenseId");
          if (licenseId == null) {
            var license = await API.get("license", "/license");
            sessionStorage.setItem("licenseId", license.licenseId);
            licenseId = license.licenseId
          }
          admin = user.signInUserSession.accessToken.payload["cognito:groups"].includes(licenseId + ".admin");
        });
        this.setState({ isAuthenticated: true, isAdminUser: admin, email: userEmail });
      }
    }
    catch (e) {
      this.setState({ isAuthenticated: false, isAdminUser: false });
      if (e != 'No current user') {
        this.setState({ alertMessage: e.message});
      }
    }
    this.setState({ isAuthenticating: false });
  }

  handleLogout = async event => {
    await Auth.signOut();
    this.setState({ isAdminUser: false });
    this.setState({ isAuthenticated: false });
    sessionStorage.removeItem("licenseId");
    this.props.history.push("/login");
  }

  render() {
    const childProps = {
      emailAddress: this.state.emailAddress,
      isAuthenticated: this.state.isAuthenticated,
      isAdminUser: this.state.isAdminUser, 
      userHasAuthenticated : this.userHasAuthenticated,
      emailAddressHandler: this.emailAddressHandler
    };

    return (
      !this.state.isAuthenticating &&
      <div>
        <Navbar bg="dark" variant="dark">
          <NavbarBrand href="/"><img src="/images/logo-white.png" alt="Absolute Technology" height="42" /></NavbarBrand>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
              
            </Nav>
            <Nav className="ml-auto">
             { this.state.isAuthenticated ?
              <Nav.Link href="/">Home</Nav.Link> : <span/> }
             { this.state.isAuthenticated ?
              <NavDropdown title="Admin" id="collasible-nav-dropdown">
                { this.state.isAdminUser ? <span>
                <NavDropdown.Item href="/admin/users">List Users</NavDropdown.Item>
                <NavDropdown.Item href="/admin/register">Register Users</NavDropdown.Item> </span> : <span/> }
                { this.state.isAuthenticated ?
                <NavDropdown.Item href="/settings/password">Change Password</NavDropdown.Item>
               : <span/>
              }
              </NavDropdown> : <span/>
              }
              { this.state.isAuthenticated
                ? <Nav.Link href="/login"  onClick={() => this.handleLogout()}>Sign Out</Nav.Link>
                : <Nav.Link href="/login">Login</Nav.Link>
              }
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Alert color="warning" isOpen={!this.state.alertMessage == ""} toggle={this.onDismiss} fade={false}>
          <h4 className="alert-heading">Error</h4>
          <p>{this.state.alertMessage}</p>
        </Alert>
        <Routes childProps={childProps}/>
        <ClearCache >
        {({ isLatestVersion, emptyCacheStorage }) => (
          <div style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
        }}> 
            {!isLatestVersion && (
              <p>
                <a href="#" onClick={e => {
                    e.preventDefault();
                    emptyCacheStorage();
                  }}
                >Update Version</a>
              </p>
            )}
          </div>
        )}
      </ClearCache>
      </div>
    );
  }
}

export default withRouter(App);


